module.exports = __webpack_public_path__ + "static/img/VDappScenarios2-2.adc572d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VDappScenarios2-2.png
// module id = diQT
// module chunks = 0